import { render, staticRenderFns } from "./manageModel.vue?vue&type=template&id=55c7ea0e&scoped=true&"
import script from "./manageModel.vue?vue&type=script&lang=js&"
export * from "./manageModel.vue?vue&type=script&lang=js&"
import style0 from "./manageModel.vue?vue&type=style&index=0&id=55c7ea0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7ea0e",
  null
  
)

export default component.exports